import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import CiselnikPolozka from '../../../model/CiselnikPolozka';
import { ClientStatus } from '../../../model/ClientStatus';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { fetchCiselnikPolozky } from '../../../client/external/ciselnikPolozkaClient';

interface ReturnType {
  polozkyCiselnik?: CiselnikPolozka[];
  polozkyCiselnikStatus: ClientStatus;
}

export default (
  ids: string[],
  typy: TypCiselnikaEnum[],
  platny: boolean,
  kody: string[],
  shouldFetch = true,
): ReturnType => {
  const {
    data: polozkyCiselnik,
    status: polozkyCiselnikStatus,
  } = useClientFetch(
    () => fetchCiselnikPolozky(ids, typy, platny, '', kody, undefined, shouldFetch),
    [],
  );

  return {
    polozkyCiselnik: polozkyCiselnik || undefined,
    polozkyCiselnikStatus,
  };
};
